module.exports = __webpack_public_path__ + "img/data-handling-screen-1.dbf1cbc.jpg";